export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5357.22418b46.jpg";